import { PlanDetails } from '@editor/components/PricingPlan/PlanDetails';
import type { SubscriptionPlanType } from '@repo/subscription/api';

import usePricingPlansData from '../../hooks/usePricingPlansData';
import useSelectedAddon from '../../hooks/useSelectedAddon';

import { RightColumnNonTrial, RightColumnPlanDetails } from './styles';

/**
 * Displays the features of the plan the user is upgrading to
 *
 * @param plan - The subscription plan type (SubscriptionPlanType)
 */
const NonTrialRightSection: React.FC<{ plan: SubscriptionPlanType }> = ({
  plan,
}) => {
  const selectedAddon = useSelectedAddon();
  const pricingPlansData = usePricingPlansData({ addon: selectedAddon });

  return (
    <RightColumnNonTrial data-testid="subscriptionModal--non-trial-right-section">
      <RightColumnPlanDetails>
        <PlanDetails
          {...pricingPlansData[plan]}
          yearly
          quantity={1}
          type={plan}
        />
      </RightColumnPlanDetails>
    </RightColumnNonTrial>
  );
};

export default NonTrialRightSection;
